import { alertService } from "src/services";
import { fetchWrapper } from "./fetch-wrapper";

export const validateUser = async () => {
  if (typeof window === "undefined") return;
  try {
    const user = JSON.parse(localStorage.getItem("BetaUser") || "");
    const token = user.token;
    const headers = { Authorization: "Bearer " + token };
    const response = await fetchWrapper.post(
      "/api/users/validate",
      {},
      headers,
    );
    const updatedUserData = {
      ...user,
      name: response.name,
      email: response.email || user.email,
      customer_email: response.customer_email,
      phone_number: response.phone_number,
      is_subscribed: response.is_subscribed,
      is_free: response.is_free,
      free_user_source_date: response.free_user_source_date,
      last_source_date: response.last_source_date,
      latestSymbol: response.latestSymbol,
      next_working_day: response.next_working_day,
      answers_submitted: response.answers_submitted,
      market_prediction: response.market_prediction,
      plan: response.plan,
      planExpiry: response.planExpiry,
      currentBillingCycle: response.currentBillingCycle,
      upcomingPlan: response.upcomingPlan,
      upcomingBillingCycle: response.upcomingBillingCycle,
      is_trial: response.is_trial,
      isHighestPlan: response.isHighestPlan,
      portfolio_count: response.portfolio_count,
      watchlist_count: response.watchlist_count,
      risk_profile: response.risk_profile,
    };
    localStorage.setItem("BetaUser", JSON.stringify(updatedUserData));
    if (!response.is_subscribed && !response.is_free) {
      const allowedPaths = [
        "/profile",
        "/subscription",
        "/payment-success",
        "/support",
        "/testimonials",
        "/refund-policy",
        "/shipping-and-delivery-policy",
      ];
      if (!allowedPaths.some((p) => window.location.pathname.startsWith(p))) {
        window.location.href = "/subscription";
      }
    }
  } catch (error: unknown) {
    if (typeof error === "string" && error === "Unauthorized") {
      alertService.error("Session expired");
      localStorage.removeItem("BetaUser");
      window.location.href = "/";
    } else if (isFetchWrapperError(error)) {
      if (error.response) {
        if (error.response.status === 401) {
          alertService.error(error.message ?? "Something went wrong");
          localStorage.removeItem("BetaUser");
          window.location.href = "/";
        } else {
          console.error("Error validating user:", error);
        }
      } else if (error.request) {
        console.error("No response received:", error.request);
      }
    } else {
      console.error("Unexpected error:", error);
    }
  }
};

// Optional type guard helper
function isFetchWrapperError(error: unknown): error is {
  response?: { status: number };
  request?: unknown;
  message?: string;
} {
  return (
    typeof error === "object" &&
    error !== null &&
    ("response" in error || "request" in error || "message" in error)
  );
}
